export default "__VITE_ASSET__D0aLN0hw__"